import { render, staticRenderFns } from "./AddPropertyFloorModal.vue?vue&type=template&id=10a2115a&lang=pug&"
import script from "./AddPropertyFloorModal.vue?vue&type=script&lang=ts&"
export * from "./AddPropertyFloorModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports